<script>
	import { pageOffset, isPortraitScreen } from '../js/model/stores';
	import { animateElement } from '../js/utils/animate';

	let _dog;
	let _bark;
	let startOffset;
	let lastOffset;
	let scrollDirectionDown = true;
	let legs = false;
	let portrait;

	let stayAndBark;

	export let width;

	let animation = (value) => {

		// The animateElement callback is called on element-visibility
		animateElement(value, _dog, (currentPageOffset) => {

			// The dog is visible for the first time?
			if (!startOffset || !lastOffset) {
				startOffset = window.scrollY + _dog.getBoundingClientRect().top;
				lastOffset = startOffset;
			}

			// Move the dog
			scrollDirectionDown = lastOffset < currentPageOffset;
			lastOffset = currentPageOffset;

			const newX = Math.max(0, (currentPageOffset - startOffset) * 0.03);
			_dog.style.transform = `translateX(${newX}vw) ${scrollDirectionDown ? '' : 'scaleX(-1)'}`;

			// Let the dog bark whenever the user stops scrolling
			clearTimeout(stayAndBark);
			stayAndBark = setTimeout(barking, 500);
		});
	};

	function barking() {
		_bark.classList.remove('bark--loud');
        setTimeout(() => { _bark.classList.add('bark--loud'); }, 100);
	}

	function moveLegs() {
		if (_dog.classList.contains('legs_move')) {
			_dog.classList.remove('legs_move');
			return;
		}
		_dog.classList.add('legs_move');
	}

	let prepareScene = () => {
		if (!_dog) {
			requestAnimationFrame(prepareScene);
			return;
		}

		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
		pageOffset.subscribe(animation);
	};

	prepareScene();

</script>

<style>
	.dog {
		left: 0;
		top: -3vh;
		position: absolute;
	}

	.dog.portrait {
		left: 1em;
		top: 7vh;
	}

	.dog > svg {
		width: auto;
		height: 7vh;
	}

	.dog.portrait > svg {
		height: 10vh;
	}

	#leg_1, #leg_2, #leg_3 {
		transform: unset;
	}

	.legs_move svg #leg_1 {
		transform: translateX(2px);
	}

	.legs_move svg #leg_2 {
		transform: translateX(-2px);
	}

	.legs_move svg #leg_3 {
		transform: translateX(2px);
	}

	.bark {
		position: absolute;
		left: 90%;
		top: 50%;
		opacity: 0;
	}

	.bark svg {
		width: auto;
		height: 3vh;
	}

	.bark--loud {
		animation: barking 2s 1;
	}

	@keyframes barking {
		0% { opacity: 1 }
		20% { opacity: 0 }
		29% { opacity: 0 }
		30% { opacity: 1 }
		40% { opacity: 0 }
		49% { opacity: 0 }
		50% { opacity: 1 }
		60% { opacity: 0 }
	}
</style>

<div class:portrait class="dog" bind:this={_dog}>
	<svg style="width: {width};" width="98" height="106" viewBox="0 0 98 106" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path id="leg_1" d="M74.718 85.5381H61.3567V105.401H74.718V85.5381Z" fill="#22398E"/>
		<path id="leg_2" d="M52.7419 85.5381H39.3806V105.401H52.7419V85.5381Z" fill="#5A97C3"/>
		<path id="leg_3" d="M30.7663 85.5381H17.405V105.401H30.7663V85.5381Z" fill="#22398E"/>
		<path d="M96.342 4.85607L72.4323 28.7618C65.9275 22.258 65.9275 11.5356 72.4323 5.03184C79.113 -1.64769 89.6614 -1.64769 96.342 4.85607Z" fill="#5A97C3"/>
		<path d="M74.7177 41.5938H30.7661V85.5381H74.7177V41.5938Z" fill="#22398E"/>
		<path d="M80.1677 55.8317C77.7064 55.8317 75.7725 53.8982 75.7725 51.4373C75.7725 48.9764 77.7064 47.0429 80.1677 47.0429C82.629 47.0429 84.5629 48.9764 84.5629 51.4373C84.7387 53.7224 82.629 55.8317 80.1677 55.8317ZM65.4 38.0782C62.9387 38.0782 61.0048 36.1447 61.0048 33.6838C61.0048 31.2229 62.9387 29.1136 65.4 29.1136C67.8613 29.1136 69.7951 31.0471 69.7951 33.508C69.7951 35.9689 67.8613 38.0782 65.4 38.0782ZM94.2322 49.328C92.4742 44.582 89.8371 40.1875 86.6725 36.3204C85.7935 37.3751 84.5629 38.0782 83.1564 38.0782C80.6951 38.0782 78.7613 36.1447 78.7613 33.6838C78.7613 32.2776 79.4645 31.0471 80.3435 30.344C72.7838 24.3676 63.4661 20.8521 53.0935 20.8521V64.7963H97.0451C97.0451 59.1715 96.1661 54.0739 94.2322 49.328Z" fill="#22398E"/>
		<path d="M86.6725 36.3204C87.2 35.6173 87.5516 34.5629 87.5516 33.684C87.5516 31.2231 85.6178 29.2895 83.1565 29.2895C82.1016 29.2895 81.0467 29.6409 80.3435 30.344C82.629 32.1018 84.7387 34.0353 86.6725 36.3204Z" fill="#22398E"/>
		<path d="M34.4583 4.85607L58.1921 28.7618C64.697 22.258 64.697 11.5356 58.1921 5.03184C51.6873 -1.64769 41.1389 -1.64769 34.4583 4.85607Z" fill="#5A97C3"/>
		<path d="M24.789 40.8904C22.3277 40.8904 20.3938 38.9569 20.3938 36.496C20.3938 34.0351 22.3277 32.1016 24.789 32.1016C27.2503 32.1016 29.1841 34.0351 29.1841 36.496C29.1841 38.7811 27.2503 40.8904 24.789 40.8904Z" fill="#22398E"/>
		<path d="M8.96613 32.629C4.04355 32.629 0 28.5861 0 23.6643C0 18.7426 4.04355 14.6997 8.96613 14.6997C13.8887 14.6997 17.9323 18.7426 17.9323 23.6643C17.9323 28.5861 14.0645 32.629 8.96613 32.629Z" fill="#22398E"/>
		<path d="M53.0452 41.3804L74.5419 65.6752L75.7725 64.6205L53.0452 39.3804V41.3804Z" fill="#C9468A"/>
	</svg>
	<div class="bark bark--loud" bind:this={_bark}>
		<svg style="width: calc({width} / 2);" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M30.7825 0L23.8373 -3.03582e-07C23.8373 13.1251 13.1842 23.8371 0.000197322 23.8371L0.000197019 30.7823C17.0099 30.7823 30.7825 17.0097 30.7825 0Z" fill="#22398E"/>
			<path d="M37.7865 -3.03582e-07L44.7317 0C44.7317 24.72 24.7203 44.7314 0.000276518 44.7314L0.000276821 37.7863C20.8946 37.7863 37.7865 20.8354 37.7865 -3.03582e-07Z" fill="#22398E"/>
		</svg>
	</div>
</div>

